import keyMirror from 'keymirror';

/**
 * Defines common states for form components.
 *
 * INITIAL: The form is in the initial input state.
 * UNSAVED: The form has changes that have been made but have not been submitted.
 * PROCESSING: The form has been submitted for processing.
 * ERROR: One or more of the form fields is invalid.
 * VALID: The form is ready for processing.
 * COMPLETED: The form has been successfully submitted.
 * FAILURE: There was an error processing the form.
 */
const FormState = keyMirror({
  INITIAL: null,
  UNSAVED: null,
  COMPLETED: null,
  PROCESSING: null,
  ERROR: null,
  VALID: null,
  FAILURE: null
});

export default FormState;



// WEBPACK FOOTER //
// ./src/constants/FormState.js